import { LugarInteresPage } from './../lugar-interes/lugar-interes';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, MenuController } from 'ionic-angular';
import { BuscadorPage } from '../buscador/buscador';
import { Consultas } from '../../providers/consultas';
import { Lugar } from '../../models/lugar.model';
import { VariablesGlobales } from '../../providers/variables-globales';

/**
 * Generated class for the FiestasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-lugares-interes',
  templateUrl: 'lugares-interes.html',
  providers: [ Consultas ]
})
export class LugaresInteresPage {
  public nombrePueblo: string;
  public idCiudad: number;
  public loader: any;
  public lugares: Array<Lugar>;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public consultas:Consultas,
    public menuCtrl:MenuController,
    public toastCtrl:ToastController,
    public global: VariablesGlobales,) {
    this.idCiudad = this.navParams.get("idCiudad");
    this.nombrePueblo = this.navParams.get("nombrePueblo");
    this.loader = this.loadingCtrl.create();
  }
  goToLugar(lu){
    this.navCtrl.push(LugarInteresPage,{lugar:lu});
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad LugaresPage');
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  ngOnInit(){
    this.lugares = new Array<Lugar>();
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
        this.consultas.getLugares(this.idCiudad).subscribe(x=>
          {
            if(!x){
              let toast = this.toastCtrl.create({
                  message: 'No hay datos sobre lugares de este pueblo',
                  duration: 3000,
                  position: 'bottom'
                });

                toast.onDidDismiss(() => {
                  console.log('Dismissed toast');
                });

                toast.present();
                this.navCtrl.pop();
            }
            this.lugares = x as Array<Lugar>;
            console.log(this.lugares);
            this.loader.dismiss();
          },error=>{
            console.log(error);
            this.loader.dismiss();
          }
          );
    });
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}




// WEBPACK FOOTER //
// ./src/pages/lugares-interes/lugares-interes.ts